import axios from "axios";
import { getAccessToken } from "../components/Utils/Utils.js";
import { getBrandingSettings } from "@/config/branding";

const headers = {
  Accept: "application/json",
};

const getBaseUrl = () =>
  process.env.REACT_APP_SOPHYAPP_API_URL +
  `/de/react/${getAccessToken()}/settings`;

// Branded hosts have no therapist sign-up, so their links point to sophyapp.
const SOPHYAPP_ORIGIN = "https://therapeut.sophyapp.com";

// A referral link (…/?ref=SOPHY-XXXXX) opens the registration with the code
// filled in. It is kept for this tab so a reload of the login page keeps it.
const STORAGE_KEY = "referral_code";

export const referralService = {
  /**
   * The practice's own code, what it brought in so far, and whether this
   * account still has a referral discount for its first order
   */
  getReferral: async () => {
    const response = await axios.get(`${getBaseUrl()}/referral`, { headers });
    return response.data;
  },

  /**
   * Enter a code after the sign-up (only before the first order)
   */
  redeem: async (code) => {
    const response = await axios.post(
      `${getBaseUrl()}/redeem_referral`,
      { code },
      { headers }
    );
    return response.data;
  },
};

export const buildReferralLink = (code) => {
  const brand = getBrandingSettings(window.location.hostname);
  const origin =
    brand.name === "sophyapp" ? window.location.origin : SOPHYAPP_ORIGIN;
  return `${origin}/?ref=${encodeURIComponent(code)}`;
};

// Fallback for this page load when sessionStorage is blocked.
let capturedCode = "";

// Stores the code of a referral link and returns it ("" without one).
export const captureReferralCode = () => {
  const code = (new URLSearchParams(window.location.search).get("ref") || "")
    .trim()
    .toUpperCase();
  if (code) {
    capturedCode = code;
    try {
      sessionStorage.setItem(STORAGE_KEY, code);
    } catch (e) {
      // kept in capturedCode
    }
  }
  return code;
};

export const getStoredReferralCode = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || capturedCode;
  } catch (e) {
    return capturedCode;
  }
};

export const clearStoredReferralCode = () => {
  capturedCode = "";
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // nothing stored
  }
};
